import { useCallback, useState } from "react";

import { useTranslation } from "react-i18next";

import { useDetailsStore } from "@/stores/useDetailsStore";
import { useEmailTransferStore } from "@/stores/useEmailTransferStore";
import { useCompaniesTableStore } from "@/stores/useTableStore";

import useAxiosPrivate from "../../../../../api/hooks/useAxiosPrivate";
import { ApiResources } from "../../../../../api/resources";
import useResponse from "../../../../../shared/hooks/useResponse";

const useCompaniesTabDetails = () => {
  const { getData } = useAxiosPrivate();
  const { handleCommonError } = useResponse();
  const { t } = useTranslation();

  const isTableLoading = useCompaniesTableStore((state) => state.loading);
  const isDetailsLoading = useDetailsStore((state) => state.isLoading);

  const setEmailTransferDetails = useEmailTransferStore(
    (state) => state.setDetails
  );

  const [isLoading, setIsLoading] = useState(false);

  const getTabDetailsData = useCallback(
    async (companyId: string, resource: ApiResources) => {
      const emailTransferTab = resource === ApiResources.EmailRecipients;

      setIsLoading(true);
      setEmailTransferDetails(null);
      try {
        const response = await getData(`${resource}/${companyId}`);
        emailTransferTab && setEmailTransferDetails(response.data);
      } catch (error) {
        handleCommonError(error, t);
      } finally {
        setIsLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      getData,
      handleCommonError,
      setEmailTransferDetails,
      isTableLoading,
      isDetailsLoading
    ]
  );

  return { getTabDetailsData, isLoading };
};

export default useCompaniesTabDetails;
